<template>
  <div class="header">
    <div class="logo">
      <router-link to="/"><img :src="logoImg" alt="博源科技"></router-link>
    </div>
    <ul>
      <li v-for="(item, index) in menuItems" :key="index">
        <a
          v-if="item.external"
          :href="item.route"
          target="_blank"
          class="yiji"
        >{{ item.label }}</a>
        <router-link
          v-else
          :to="item.route"
          class="yiji"
          :class="{ on: isActive(item.route) }"
        >{{ item.label }}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'NavHeader',
  data() {
    return {
      logoImg: require('@/assets/logo.png'),
      menuItems: [
        { label: '首页', route: '/' },
        { label: '关于博源', route: '/about' },
        { label: '新闻中心', route: '/news' },
        { label: '智慧银行', route: './images/2016121417492351.pdf', external: true },
        { label: '柜面设备', route: '/products' },
        { label: '自助银行防', route: '/security-protection' },
        { label: '网点形象', route: '/brand-vi' },
        { label: '联系我们', route: '/contact' },
      ],
    };
  },
  methods: {
    isActive(route) {
      if (route === '/') {
        return this.$route.path === '/';
      }
      return this.$route.path === route;
    },
  },
};
</script>

<style lang="less" scoped>
// 桌面导航样式已在 public/css/style.css 中全局定义
// 此处仅覆盖或补充导航 logo 图片尺寸
.header .logo img {
  height: 68px;
}
</style>
